var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 1.5,
    stroke: "#C6C2C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 14C16.25 14 13.0475 16.3325 11.75 19.625C13.0475 22.9175 16.25 25.25 20 25.25C23.75 25.25 26.9525 22.9175 28.25 19.625C26.9525 16.3325 23.75 14 20 14ZM20 23.375C17.93 23.375 16.25 21.695 16.25 19.625C16.25 17.555 17.93 15.875 20 15.875C22.07 15.875 23.75 17.555 23.75 19.625C23.75 21.695 22.07 23.375 20 23.375ZM17.75 19.625C17.75 18.38 18.755 17.375 20 17.375C21.245 17.375 22.25 18.38 22.25 19.625C22.25 20.87 21.245 21.875 20 21.875C18.755 21.875 17.75 20.87 17.75 19.625Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.353b9a2cceaa6c2ce7c6e399b3c51196.svg";
export { ForwardRef as ReactComponent };